import React from "react";
import DatePickerInner from './DatePickerInner';

export default class MyDatePicker extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: new Date()
        }
    }

    componentDidMount(){
        this.setState({value: Date.parse(this.props.value)});
    }

    handleChange(event) {
        if (this.props.onChange)
            this.props.onChange(event);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({value: this.props.value})
        }
      }

    getDate(){
        return this.state.value;
    }

    render (){

        return ( 
        <div style={mainClass}>
            <div style={name}>{this.props.name}</div>
            <DatePickerInner readOnly={this.props.readOnly ? this.props.readOnly : false} inputStyle={this.props.inputStyle} placeholder={this.props.placeholder} style={inputText} selected={this.state.value} onChange={date => {
                this.setState({value: date});
                this.handleChange(date); }
             } />
        </div>
        )
    }
}

const mainClass = {
    padding: '5px',
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}